/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S2_IntroInputs */

const tr_iletisim_s2_intro = /** @type {(inputs: Iletisim_S2_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ ürünü, faturalandırma veya genel sorularınız için:`)
};

const en_iletisim_s2_intro = /** @type {(inputs: Iletisim_S2_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For questions about the ShopPanel™ product, billing or general enquiries:`)
};

const de_iletisim_s2_intro = /** @type {(inputs: Iletisim_S2_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Fragen zum Produkt ShopPanel™, zur Rechnungsstellung oder allgemeine Fragen:`)
};

const ru_iletisim_s2_intro = /** @type {(inputs: Iletisim_S2_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По вопросам о продукте ShopPanel™, выставлении счетов или общим вопросам:`)
};

/**
* | output |
* | --- |
* | "For questions about the ShopPanel™ product, billing or general enquiries:" |
*
* @param {Iletisim_S2_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s2_intro = /** @type {((inputs?: Iletisim_S2_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S2_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s2_intro(inputs)
	if (locale === "de") return de_iletisim_s2_intro(inputs)
	if (locale === "ru") return ru_iletisim_s2_intro(inputs)
	return tr_iletisim_s2_intro(inputs)
});